const themes = {
	cssVariable: {

	},
	theme1: {
		primary: '#063c8e',
		secundary: '#0747a6',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme2: {
		primary: '#7f6c2e',
		secundary: '#e8c553',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme3: {
		primary: '#03914b',
		secundary: '#02ce69',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme4: {
		primary: '#972733',
		secundary: '#6900c3',
		iconFocus: '#fff',
		icon: '#fff'
	},
	theme5: {
		primary: '#37085c',
		secundary: '#540095',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme6: {
		primary: '#a04e1d',
		secundary: '#de6d28',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme7: {
		primary: '#ea4c89',
		secundary: '#3e39aa',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme8: {
		primary: '#9d835e',
		secundary: '#3f3f3f',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme9: {
		primary: '#3acbc7',
		secundary: '#25a5a1',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme10: {
		primary: '#635596',
		secundary: '#A4CD39',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme11: {
		primary: '#00c74d',
		secundary: '#223E6A',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#ccc',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	},
	theme12: {
		primary: '#00bbbd',
		secundary: '#009194',
		iconFocus: '#fff',
		icon: '#fff',
		contrast: '#E81756',
		neutral1: '#292929',
		neutral2: '#7b7b7b',
		neutral3: '#bcbcbc',
		color1: '#6e2bbb',
		color2: '#eff5f1',
		color3: '#582098',
		color4: '#00bbbd',
		semantic: {
			error: '#E81756',
			info: '#76b0ea',
			warn: '#eec446',
			success: '#82b517'
		}
	}
};

export default themes;



// WEBPACK FOOTER //
// ./src/modules/base/providers/themes.list.js